<script>
	import { startAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// ENV-V2115
		waermewochen: {
			element: false,
			fallbackImgUrl: './../commercial/18.BurgEins_Stromert/04.seasons/ENV-V2115-Waermewochen-2016-900x200-default/backup.webp',
			imageAltText: 'RWE - Wärmewochen - interactive Ad',
			iframeIndexUrl: './../commercial/18.BurgEins_Stromert/04.seasons/ENV-V2115-Waermewochen-2016-900x200-default/index.html',
			playTimeMs: 30000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 900,
			origHeight: 200
		},
		// RWE-0080-Raumwaerme-160x600
		raumwaerme: {
			element: false,
			fallbackImgUrl: './../commercial/18.BurgEins_Stromert/04.seasons/RWE-0080-Raumwaerme-160x600/backup.webp',
			imageAltText: 'RWE - Raumwaerme - interactive Ad',
			iframeIndexUrl: './../commercial/18.BurgEins_Stromert/04.seasons/RWE-0080-Raumwaerme-160x600/index.html',
			playTimeMs: 30000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 160,
			origHeight: 600
		},
		// RWE-0083-B2B-Solar-160x600
		solar: {
			element: false,
			fallbackImgUrl: './../commercial/18.BurgEins_Stromert/04.seasons/RWE-0083-B2B-Solar-160x600/backup.webp',
			imageAltText: 'enviaM - Solarwochen - interactive Ad',
			iframeIndexUrl: './../commercial/18.BurgEins_Stromert/04.seasons/RWE-0083-B2B-Solar-160x600/index.html',
			playTimeMs: 30000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 160,
			origHeight: 600
		},
		// ENV-V1882-PurStrom-Sky-B-160x600-sizmek
		purstrom: {
			element: false,
			fallbackImgUrl: './../commercial/18.BurgEins_Stromert/04.seasons/PurStrom-160x600/backup.webp',
			imageAltText: 'enviaM - PurStrom - interactive Ad',
			iframeIndexUrl: './../commercial/18.BurgEins_Stromert/04.seasons/PurStrom-160x600/index.html',
			playTimeMs: 13000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 160,
			origHeight: 600
		}
	};
</script>

<div class="page-energy_seasons marginbox">
	<div class="img-single">
		<img loading="lazy" alt="BurgEins stromert - Desktop-Ad-Design" src="./../img/18.BurgEins_Stromert/04.seasons/RWE_Energiekaufhaus_Landing.webp">
	</div>
	
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<div bind:this={ads.waermewochen.element} class="content waermewochen"
					 style="
								 --scale: {ads.waermewochen.scale};
								 --origWidth: {ads.waermewochen.origWidth || 0}px;
								 --origHeight: {ads.waermewochen.origHeight || 0}px;
							">
					<div class="commercial playing">
						<iframe scrolling="no" src={ads.waermewochen.iframeIndexUrl}
								style="--bg-image: url('{ads.waermewochen.fallbackImgUrl}')"
								on:load={(e) => {startAd(ads.waermewochen, () => ads = ads);e.target.setAttribute('loaded',
								'true')}}/>
					</div>
				</div>
			</div>
			<div class="flex element">
				<div class="text">
					<h2 class="caption balance">{getText("18.04.01_h2")}</h2>
					<p class="caption balance">{getText("18.04.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
				</div>
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex row">
				<div class="flex raumwaerme">
					<!-- Beginning - Ad: raumwaerme -->
					<div bind:this={ads.raumwaerme.element} class="content"
						 style="
								 --scale: {ads.raumwaerme.scale};
								 --origWidth: {ads.raumwaerme.origWidth || 0}px;
								 --origHeight: {ads.raumwaerme.origHeight || 0}px;
							">
						<div class="commercial playing">
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.raumwaerme.iframeIndexUrl}
									style="--bg-image: url('{ads.raumwaerme.fallbackImgUrl}')"
							on:load={(e) => {startAd(ads.raumwaerme, () => ads = ads);e.target.setAttribute('loaded',
								'true')}}/>
						</div>
					</div>
					<!-- End - Ad -->
				</div>
				<div class="flex solar">
					<!-- Beginning - Ad: solar -->
					<div bind:this={ads.solar.element} class="content"
						 style="
								 --scale: {ads.solar.scale};
								 --origWidth: {ads.solar.origWidth || 0}px;
								 --origHeight: {ads.solar.origHeight || 0}px;
							">
						<div class="commercial playing">
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.solar.iframeIndexUrl}
									style="--bg-image: url('{ads.solar.fallbackImgUrl}')"
							on:load={(e) => {startAd(ads.solar, () => ads = ads);e.target.setAttribute('loaded',
								'true')}}/>
						</div>
					</div>
					<!-- End - Ad -->
				</div>
				<div class="flex purstrom">
					<!-- Beginning - Ad: purstrom -->
					<div bind:this={ads.purstrom.element} class="content"
						 style="
								 --scale: {ads.purstrom.scale};
								 --origWidth: {ads.purstrom.origWidth || 0}px;
								 --origHeight: {ads.purstrom.origHeight || 0}px;
							">
						<div class="commercial playing">
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.purstrom.iframeIndexUrl}
									style="--bg-image: url('{ads.purstrom.fallbackImgUrl}')"
							on:load={(e) => {startAd(ads.purstrom, () => ads = ads);e.target.setAttribute('loaded',
								'true')}}/>
						</div>
					</div>
					<!-- End - Ad -->
				</div>
			</div>
		</div>
		
		<div class="flex col structure-3">
			<div class="flex element">
				<img loading="lazy" alt="enviaM - Email-Design"
					 src="./../img/18.BurgEins_Stromert/04.seasons/Gruppe-10.webp">
			</div>
			<div class="flex element">
				<div class="text">
					<div class="headline">
						<h2>{getText("18.04.03_h2")}</h2>
					</div>
					<div class="text_container">
					<p class="caption">{getText("18.04.04_caption")}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile 0 $media-gap 0;
	}

	.page-energy_seasons {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}

		.commercial {
			position: relative;
			width: 100%;

			&.playing {
				height: calc(600px * var(--scale));
			}
		}

		.content {
			flex: 1 100%;
			width: 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2,
		.structure-3 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			flex-direction: column;

			@include for-tablet-portrait-up {
				width: 55%;
				padding-right: $media-gap;
			}

			.text {
				padding-right: $media-gap;
				flex: 1;
				display: flex;
				flex-direction: column;
				align-items: end;

				@include for-tablet-landscape-up {
					max-width: 400px;
					text-align: right;
				}

				* {
					width: 100%;
				}
			}

			.element {
				margin-bottom: $media-gap;

				&:last-of-type {
					@include for-tablet-landscape-up {
						justify-content: end;
					}
				}
			}
		}
		
		.structure-2 {
			@include for-tablet-portrait-up {
				flex-flow: column wrap;
				width: 45%;
			}
			
			.row {
				flex: 1;
				width: 100%;
				height: fit-content;
				flex-flow: row nowrap;
				gap: $media-gap;

				> .flex {
					width: calc((100% - $media-gap - $media-gap) / 3);
					margin-bottom: $media-gap;
					height: fit-content;
				}

				@include for-tablet-portrait-up {
					> .flex:last-of-type {
						padding-right: 0; //since :not(last-of-type) isn't working
					}
				}
			}
		}
		
		.structure-3 {
			.element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					width: 100%;
					text-align: right;

					.text {
						display: flex;
						width: 100%;

						.headline {
							//from image to align with light-blue element:
							flex: 1000;

							h2 {
								width: 60%;
								float: right;
								margin-right: px-to-em(20);
							}
						}
						.text_container {
							flex: calc(2097 - 1000);
							text-align: left;
						}
					}
				}
				
			}
		}
		
		.text {
			margin: 0;
		}
	}

	.commercial iframe {
		border: 0;
		width: 100%;
		height: 100%;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(.commercial iframe[loaded]) {
		background-image: none !important;
	}

	.raumwaerme .commercial > img,
	.solar .commercial > img,
	.purstrom .commercial > img {
		max-width: 100%;
		max-height: 100%;
	}

	.raumwaerme .commercial > iframe,
	.solar .commercial > iframe,
	.purstrom .commercial > iframe {
		scale: var(--scale);
		width: 160px;
		height: 600px;
		position: relative;
		top: 0;
		transform-origin: top left;
	}

	.waermewochen {
		height: calc(200px * var(--scale));
		iframe {
			scale: var(--scale);
			width: 900px;
			height: 200px;
			transform-origin: top left;
		}
	}
</style>
